<template>
  <div class="burger">
    <div class="lines-wrapper" @click="clickBurger">
      <div class="lines"></div>
    </div>
    <div class="content" :class="{burgerOpen: isClicked}">
      <div class="link-container">
        <button
          :class="{isActiveLink: $route.meta.key === 1}"
          class="link border-none"
          @click="isToggled = !isToggled"
        >
          Торговым центрам
          <img class="arrow" src="@/assets/images/arrow.svg" alt />
        </button>
        <b-collapse :visible="isToggled">
          <button
            class="shop-link"
            @click="routerPush(`autoReg`)"
            :class="{isActiveShopLink: $route.meta.index === 1}"
          >Автоматизиованная стойка регистрации</button>
          <button
            class="shop-link"
            @click="routerPush(`independReg`)"
            :class="{isActiveShopLink: $route.meta.index === 2}"
          >Самостоятельная регистрация</button>
          <button
            class="shop-link"
            @click="routerPush(`loyalProgram`)"
            :class="{isActiveShopLink: $route.meta.index === 3}"
          >Программа лояльностей покупателей ТРЦ</button>
        </b-collapse>
      </div>
      <button
        class="link"
        :class="{isActiveLink: $route.meta.key === 2}"
        @click="routerPush(`brands`)"
      >
        FMCG Брендам
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </button>

      <button
        class="link"
        :class="{isActiveLink: $route.meta.key === 3}"
        @click="routerPush(`franchisors`)"
      >
        Франчайзерам
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </button>
      <button
        class="link"
        v-if="$route.meta.path === 2"
        :class="{isActive: $route.meta.path === 1}"
        @click="routerPush(`products`)"
      >
        Продукты
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </button>
      <button
        class="link"
        v-if="$route.meta.path === 1"
        :class="{isActive: $route.meta.path === 2}"
        @click="routerPush(`blog`)"
      >
        Блог
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </button>
    </div>
    <div class="dark-background" v-if="isClicked" @click="clickBurger"></div>
  </div>
</template>

<script>
import BlogNav from "./blog-nav";

export default {
  data() {
    return {
      isClicked: false,
      isToggled: false
    };
  },
  components: {
    BlogNav
  },
  methods: {
    clickBurger() {
      this.isClicked = !this.isClicked;
      this.isToggled = false;
      let body = document.querySelector(`body`);
      if (this.isClicked) {
        body.style.overflow = `hidden`;
      } else {
        body.style.overflow = ``;
      }
    },
    routerPush(name) {
      this.clickBurger();
      this.$router.push({ name: `${name}` });
      window.scrollTo(0, 0);
    }
  }
};
</script>

